<template>
  <div class="wrld-overview">
    <v-container
      class="pa-4"
    >
      <v-row>
        <v-col
        sm="6"
        v-for="(item, key) in this.overview"
        :key="key"
        >
          <v-col>
            <v-row>
              <v-col
                sm="4"
                class="text-right"
              >
                <span class="subheading">
                  <strong>{{Object.values( item )[0]}}</strong>
                </span>
              </v-col>
              <v-col offset-sm="1">
                <span class="subheading">{{Object.values( item )[1]}}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
export default {
  name: 'wrld-overview',
  props: {
    overview: Array
  }
}
</script>

<style scoped lang="scss">

</style>
